var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-tag',{attrs:{"type":_vm.colorStatus,"rounded":""}},[_vm._v(_vm._s(_vm.status))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }